import { Layout } from "antd";
import React from "react";
import styled from "@emotion/styled";

import Breadcrumb, { Trail } from "components/Breadcrumb";

export const PageTitle = styled("h2")`
  color: #333;
`;

export const PageSubtitle = styled("small")`
  color: #666;
  font-size: 0.75em;
`;

const Header = styled(Layout.Header)`
  background-color: transparent;
  padding: 10px 15px 5px;
  height: auto;
  line-height: 1.2em;
`;

const Title = styled("div")`
  padding-bottom: 5px;
  border-bottom: 1px solid #898989;
`;

interface PageHeaderProps {
  trail: Trail;
}

const PageHeader: React.SFC<PageHeaderProps> = ({ trail, children }) => (
  <Header>
    <Breadcrumb trail={trail} />
    <Title>{children}</Title>
  </Header>
);

export default PageHeader;
